module.exports = __webpack_public_path__ + "static/media/features.c8aa5fcc.jpg";